import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/imgs/icon_48.png")